import { configureApi } from '@provisium/web-api'

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? '/api/v1'

configureApi({
  baseUrl: API_BASE_URL,
})

export {
  ApiError,
  apiRequest,
  apiUpload,
  getAccessToken,
  setAccessToken,
} from '@provisium/web-api'
